import { render, staticRenderFns } from "./StudySet.vue?vue&type=template&id=6f4b09ee"
import script from "./StudySet.vue?vue&type=script&lang=js"
export * from "./StudySet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports